import { render } from "./RejectMessage.vue?vue&type=template&id=246f7ae2&scoped=true"
import script from "./RejectMessage.vue?vue&type=script&lang=js"
export * from "./RejectMessage.vue?vue&type=script&lang=js"

import "./RejectMessage.vue?vue&type=style&index=0&id=246f7ae2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246f7ae2"]])

export default __exports__